import { UntypedFormGroup } from '@angular/forms';
import { Params } from '@angular/router';
import { DSM3SelectOption } from '@eredes/dsm3';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';

export class CpeFilterViewModel {
  cpeForm: UntypedFormGroup;

  filters: Params;

  isFiltersReady = false;
  declarationsTerms = false;

  // District
  filterDistrict: string;
  filterDistrictSelected: [];
  districtListAll = [];
  districtList = [];
  districtList$: Subject<DSM3SelectOption[]> = new BehaviorSubject<DSM3SelectOption[]>([]);

  // County
  countyListAll = [];
  countyList = [];
  countyList$: Subject<DSM3SelectOption[]> = new BehaviorSubject<DSM3SelectOption[]>([]);

  // Street
  streetList$: Subject<DSM3SelectOption[]> = new BehaviorSubject<DSM3SelectOption[]>([]);
  streets = [];
  selectedStreet: string = null;

  // Floor
  floorList$: Subject<DSM3SelectOption[]> = new BehaviorSubject<DSM3SelectOption[]>([]);

  // Counter
  filterCounterSelected: [];
  counterList = [];
  counterList$: Subject<DSM3SelectOption[]> = new BehaviorSubject<DSM3SelectOption[]>([]);

  // County
  filterCountySelected: [];
  filterCounty: string;
  filterCounter: string;

  // Modal
  hasCopyToClipboard = false;
  cpeCode: string = null;
  currentModal: any;
}
